<div
    class="fixed bottom-16 left-0 z-30 full-height-without-navigation w-full md:bottom-0"
    [ngClass]="{ block: open | async, hidden: !(open | async) }"
    (click)="hide()"></div>
<nav
    class="slide-left fixed bottom-16 left-0 z-30 inline-block full-height-without-navigation bg-white md:slide-top md:top-(--navigation-height) md:bottom-auto md:h-auto md:w-full md:backdrop-blur-lg md:backdrop-saturate-100"
    [ngClass]="{
        'md:bg-white/87!': isNavbarInverseColors,
        'md:bg-white/24!': !isNavbarInverseColors,
        expanded: (open | async),
    }">
    <ul class="space-y-5 p-4 pt-8 pr-8 md:space-y-0 md:p-0 md:pb-4">
        <li class="pb-4 md:hidden">
            <app-link link="/" additionalClasses="flex w-full max-w-60">
                <app-fa-logo
                    logoStyle="long"
                    [showAdventureTrips]="true"
                    theme="dark"></app-fa-logo>
            </app-link>
        </li>
        @for (page of sidebarMenu; track page.id) {
            <li
                [ngClass]="{
                    'md:hover:bg-white/24': !isNavbarInverseColors,
                    'md:hover:bg-lightergrey': isNavbarInverseColors,
                }">
                <app-link
                    [link]="page.url"
                    [additionalClasses]="[
                        'py-4 text-xl font-bold text-darkgrey md:block md:w-full md:text-lg md:font-normal',
                        isNavbarInverseColors
                            ? 'md:text-darkgrey'
                            : 'md:text-white',
                    ]">
                    <div class="mx-auto max-w-(--breakpoint-xl) md:px-[3%]">
                        {{ page.label }}
                    </div>
                </app-link>
            </li>
        }
    </ul>
</nav>
